let platformConfig = {}
// 測試環境
const devConfig = {
  title: 'appName',
  baseURL: 'https://game-texasb.locas.tech/gateway',
  // webSocketUrl: 'wss://dev.texas.net/gateway/websocket/connect'
}
// release環境(上正式前測試)
const releaseConfig = {
  title: 'appName',
  baseURL: '',
  // webSocketUrl: 'wss://dev.texas.net/gateway/websocket/connect'
}
// 正式環境
const productionConfig = {
  title: 'appName',
  baseURL: '',
  // webSocketUrl: 'wss://dev.texas.net/gateway/websocket/connect'
}
const releaseQaConfig = {
  title: 'appName',
  baseURL: '',
  // webSocketUrl: 'wss://dev.texas.net/gateway/websocket/connect'
}
switch (process.env.NODE_ENV) {
  case 'production': // texas正式
    platformConfig = productionConfig
    break
  case 'release': // release測試
    platformConfig = releaseConfig
    break
  case 'release-qa': // release-qa測試
    platformConfig = releaseQaConfig
    break
  case 'development': // texas測試
    platformConfig = devConfig
    break
  default:
    platformConfig = devConfig
}
export default platformConfig
